import { useMemo } from 'react'
import { selectors, SectionNames } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useI18n } from 'builder/hooks/useI18n'
import { LOCALIZATION_PREFIX } from '../../constants'
import { useStepByStepFlowABTest } from '../../hooks/useStepByStepFlowABTest'
import { ContentBannerContainer, ContentBannerText } from './styles'

export const ContentBanner = () => {
  const { i18n } = useI18n()
  const currentStep = useTypedSelector(selectors.stepByStepFlowCurrentStep)
  const { isContentBannerActive } = useStepByStepFlowABTest()

  const bannerText = useMemo(() => {
    switch (currentStep) {
      case SectionNames.profile:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.profile`)
      case SectionNames.workExperiences:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.work_experiences`)
      case SectionNames.educations:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.educations`)
      case SectionNames.skills:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.skills`)
      case SectionNames.details:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.details`)
      case SectionNames.addAdditionalSection:
        return i18n.t(`${LOCALIZATION_PREFIX}.section_banner.additional_sections`)
      default:
        return null
    }
  }, [currentStep, i18n])

  return isContentBannerActive && bannerText ? (
    <ContentBannerContainer>
      <ContentBannerText dangerouslySetInnerHTML={{ __html: bannerText || '' }} />
    </ContentBannerContainer>
  ) : (
    <></>
  )
}
